<template>
  <div v-zpm="{ sectionid: 105, areaexposure: 105 }" class="product-msg-wrapper">
    <!-- 商品信息区域 -->
    <div class="product-infos">
      <!-- 金融分期 -->
      <finance-info
        v-if="
          state.fromInstallment &&
          dataInfo.installmentInfo &&
          dataInfo.installmentInfo.amountPerMonth
        "
        :dataInfo="dataInfo"
        :feedbackData="feedbackData"
      >
        <!-- 红包+秒杀 | 秒杀-->
        <redpack-seckill
          v-zpm="{ sortid: 3 }"
          :priceStatus="priceStatus"
          :countDownTime="countDownTime"
          :countDownDesc="countDownDesc"
          :handPriceVo="handPriceVo"
          :tagInfo="tagInfoData"
          :superLevel="superLevel"
          @finish="countDownFinish"
          :title="baseInfoMsg.title"
        />
      </finance-info>
      <!-- 非大促 -->
      <usually-info
        v-else-if="!superLevel && !billionLevel"
        v-zpm="{ sortid: 1 }"
        :dataInfo="dataInfo"
        :feedbackData="feedbackData"
        :priceStatus="priceStatus"
        :costPerformanceText="costPerformanceText"
      >
        <!-- 红包+秒杀 | 秒杀-->
        <redpack-seckill
          v-zpm="{ sortid: 3 }"
          :priceStatus="priceStatus"
          :countDownTime="countDownTime"
          :countDownDesc="countDownDesc"
          :handPriceVo="handPriceVo"
          :superLevel="superLevel"
          :tagInfo="tagInfoData"
          :couponTipContent="dataInfo.couponTipContent"
          :title="baseInfoMsg.title"
          @finish="countDownFinish"
        />
        <!-- 会员体系 https://www.tapd.cn/20616901/prong/stories/view/1120616901001446819 -->
        <vip-member
          :userVipInfo="baseInfoMsg.userVipInfo"
          v-if="baseInfoMsg.userVipInfo"
          @updateBaseInfo="updateBaseInfo"
        ></vip-member>
      </usually-info>
      <!-- 大促场景 | 十亿补贴 -->
      <super-info
        v-else
        v-zpm="{ sortid: 2 }"
        :countDownTime="countDownTime"
        :countDownDesc="countDownDesc"
        :priceStatus="priceStatus"
        :superLevel="superLevel"
        :billionLevel="billionLevel"
        :dataInfo="dataInfo"
        :feedbackData="feedbackData"
        :costPerformanceText="costPerformanceText"
        :isVipMemeber="Boolean(baseInfoMsg.userVipInfo)"
        @finish="countDownFinish"
      >
        <!-- 十亿补贴新增 -->

        <!-- 红包+秒杀 | 秒杀-->
        <redpack-seckill
          v-zpm="{ sortid: 3 }"
          :priceStatus="priceStatus"
          :countDownTime="countDownTime"
          :countDownDesc="countDownDesc"
          :handPriceVo="handPriceVo"
          :tagInfo="tagInfoData"
          :superLevel="superLevel"
          :billionLevel="billionLevel"
          :title="baseInfoMsg.title"
          @finish="countDownFinish"
        />
        <!-- 会员体系 https://www.tapd.cn/20616901/prong/stories/view/1120616901001446819-->
        <vip-member
          :userVipInfo="baseInfoMsg.userVipInfo"
          v-if="baseInfoMsg.userVipInfo"
          @updateBaseInfo="updateBaseInfo"
        ></vip-member>
      </super-info>
      <div class="product-infos__msg">
        <!-- 商品标题区域 -->
        <div class="good-title_wrapper">
          <div ref="goodsTitle" class="text">
            <label v-show="showTitleCheckMore" class="float-right">
              <span v-if="titleExpand" class="dot">...</span>
              <span
                v-if="Object.values(afterSalesService).length && titleExpand"
                class="sales-return"
                @click="$refs.saleReturnRef.PopupReturnShow = true"
              >
                <span>{{ afterSalesService.titleTagName }} </span>
                <img
                  class="right"
                  :src="
                    $setPicSize(
                      'https://pic5.zhuanstatic.com/zhuanzh/ae2cebb0-f5e1-4d38-bb7a-8a6230f3ec91.png?t=5&qa=90'
                    )
                  "
                  alt=""
                />
              </span>

              <z-icon
                class-prefix="zziconfont"
                name="unfold"
                class="title-bottom-icon"
                :class="{ 'title-top-icon': !titleExpand }"
                @click="showAllTitle"
              ></z-icon>
            </label>
            {{ dataInfo.title }}

            <span
              v-if="Object.values(afterSalesService).length"
              class="sales-return"
              @click="$refs.saleReturnRef.PopupReturnShow = true"
            >
              <span>{{ afterSalesService.titleTagName }}</span>
              <img
                class="right"
                :src="
                  $setPicSize(
                    'https://pic5.zhuanstatic.com/zhuanzh/ae2cebb0-f5e1-4d38-bb7a-8a6230f3ec91.png?t=5&qa=90'
                  )
                "
                alt=""
              />
              <!-- <z-icon class-prefix="zziconfont" name="arrow-right" class="right"></z-icon> -->
            </span>
          </div>
        </div>

        <!-- 商品tag -->
        <div v-if="goodTags.length" class="good-tag_wrapper">
          <div class="tag-list">
            <div v-for="(item, index) in goodTags" :key="item" class="tag-list__item">
              {{ item }}
              <span v-if="index < goodTags.length - 1" class="dot"></span>
            </div>
          </div>
        </div>

        <!-- 榜单 尖货 备件库  品牌馆 -->
        <rank-info
          v-if="!getQueryString('saleCombineIds')"
          v-zpm="{ sortid: 4, sortname: '榜单入口' }"
          :rankInfo="rankInfoData"
          :dataInfo="dataInfo"
          :visibilityState="visibilityState"
        />
        <div v-if="paramsBarInfo.length" class="dashed"></div>

        <!-- 成色等级信息 -->
        <div class="quality-level">
          <div class="quality-level__left">
            <quality-level
              ref="qualityRef"
              :dataInfo="dataInfo"
              :feedbackData="feedbackData"
            ></quality-level>

            <div
              v-if="levelDesc"
              class="quality-level__condition"
              @click="qualityRef.toggleConditionPopup()"
            >
              <div class="line"></div>
              <span class="quality-desc">{{ levelDesc }}</span>
              <img
                v-if="dataInfo.infoLv"
                class="quality-icon"
                :src="
                  $setPicSize(
                    'https://pic3.zhuanstatic.com/zhuanzh/72812048-627c-400f-bd2f-977bcc522469.png'
                  )
                "
                alt=""
              />
            </div>
            <div
              v-else
              class="quality-level__condition old-style"
              @click="qualityRef.toggleConditionPopup()"
            >
              <img
                v-if="dataInfo.infoLv"
                class="quality-icon old-style"
                :src="$setPicSize('c23d704f-93ea-4625-892a-143659eb8769.png')"
                alt=""
              />
            </div>
          </div>

          <div
            v-if="isShowButton"
            v-zpm="{
              sortid: 6,
              sortname: 'PK',
              legoareabackup: {
                sortName: 'PK',
                sortid: 6
              },
              areaexposure: 105
            }"
            class="quality-level__right"
            @click="pkJump"
          >
            <div class="pk-desc">PK对比</div>
          </div>
        </div>

        <!-- 质检心智条 -->
        <div v-if="paramsBarInfo && paramsBarInfo.length > 0" class="bottom-info">
          <div
            id="scrollEle"
            ref="scrollEle"
            v-zpm="{ sortid: 5, sortname: '参数条' }"
            class="report-param"
            @click="showParamsBar"
            @scroll="handleScroll"
          >
            <div v-for="(item, index) in paramsBarInfo" :key="index" class="report-item">
              <div class="report-item__text">
                <p>{{ item.value }}</p>
                <p>{{ item.key }}</p>
              </div>
              <div class="line"></div>
            </div>
          </div>

          <div
            v-if="showQuantityPoup"
            v-zpm="{ sortid: 5, sortname: '参数条' }"
            class="arrow"
            @click="showParamsBar"
          >
            <img
              :src="
                $setPicSize(
                  'https://pic6.zhuanstatic.com/zhuanzh/8c7f8bc4-1383-4c21-88df-45fa0a6452c6.png'
                )
              "
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 心智条 -->
      <div v-if="service" v-zpm="{ sortid: 0, sortname: '官方验条' }" class="mentality-bar">
        <serviceGuide :dataInfo="dataInfo" />
      </div>
    </div>
    <!-- 红包弹窗 -->
    <coupon-pop
      :dataInfo="dataInfo"
      :promotionStatus="promotionStatus"
      :feedbackData="feedbackData"
    ></coupon-pop>
    <!-- 质检参数条弹窗 -->
    <params-bar
      v-if="showQuantityPoup"
      ref="paramsBar"
      :dataInfo="dataInfo"
      :feedbackData="feedbackData"
      @openPopupWarchPedia="openPopupWarchPedia"
    />
    <!-- 心智条弹窗 -->
    <service-guide-poup
      ref="serviceGuide"
      :serviceLogos="dataInfo.serviceLogos"
      :feedbackData="feedbackData"
    ></service-guide-poup>
    <!-- 退货包邮弹窗 -->
    <sales-return-dialog ref="saleReturnRef" :dataInfo="dataInfo" />
  </div>
</template>
<script>
import { defineComponent, computed, ref, watch, onMounted, onUnmounted } from '@vue/composition-api'
import { state } from '@/store/index'
import financeInfo from './financeInfo'
import usuallyInfo from './usuallyInfo'
import superInfo from './superInfo'
import RedpackSeckill from './redpack-seckill'
import RankInfo from './rankInfo'
import { getSysType } from '@utils/ua'
import { getQueryString } from '@utils/index'
import { skipToUrl } from '@utils/native'
import { Icon } from '@zz-common/zz-ui'
import qualityLevel from './quality-level.vue'
import serviceGuide from './serviceGuide.vue'
import ParamsBar from '@/components/params-bar'
import vipMember from '@/components/vipMember.vue'
export default defineComponent({
  components: {
    financeInfo,
    usuallyInfo,
    superInfo,
    RedpackSeckill,
    RankInfo,
    qualityLevel,
    serviceGuide,
    ParamsBar,
    vipMember,
    [Icon.name]: Icon,
    serviceGuidePoup: () =>
      import(/* webpackChunkName: "serviceGuidePoup" */ './serviceGuidePoup.vue'),
    CouponPop: () => import(/* webpackChunkName: "CouponPop" */ '@/components/coupon-pop'),
    // ParamsBar: () => import(/* webpackChunkName: "params-bar" */ '@/components/params-bar'),
    SalesReturnDialog: () =>
      import(
        /* webpackChunkName: "sales-return-dialog" */ '../newActivityInfo/sales-return-popup.vue'
      )
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    baseInfoMsg: {
      type: Object,
      default: () => {}
    },
    feedbackData: {
      type: Object,
      default: () => {}
    },
    visibilityState: {
      type: String,
      default: ''
    }
  },
  setup(props, ctx) {
    const { $legoAreaExposure, $legoSend } = ctx.root
    const promotionStatus = ref(0) // 0 平常状态  1 秒杀未开始 2 秒杀开始未结束
    const started = ref(false)
    const countDownDesc = ref('距活动结束')
    const countDownTime = ref(0)
    const paramsBar = ref(null)
    const qualityRef = ref(null)
    //标题显示查看更多
    const showTitleCheckMore = ref(false)
    const titleExpand = ref(true)
    const timer = ref(null)

    const goodsTitle = ref(null)

    const startX = ref(0) // 手指开始触摸时的 X 坐标
    const endX = ref(0) // 手指离开屏幕时的 X 坐标
    const isScrolling = ref(false) // 是否正在滑动
    const direction = ref('') // 滑动方向

    const superLevel = computed(() => {
      // 搭售商详不需要秒杀场景
      return (
        !!props.dataInfo.couponLv &&
        props.dataInfo.couponLv &&
        props.dataInfo.couponLv.lv == 1 &&
        !getQueryString('saleCombineIds')
      )
    })

    const billionLevel = computed(() => {
      return props.dataInfo.actInfoVo && props.dataInfo.actInfoVo.activityType == 2 // 十亿补贴命
    })
    const handPriceVo = computed(() => {
      return props.dataInfo.handPriceVo
    })

    const showQuantityPoup = computed(() => {
      if (props.dataInfo.infoType != 1000) {
        return props.dataInfo?.luxuryDescribeInfo && props.dataInfo?.luxuryDescribeInfo.length > 0
      }
      return (
        (props.dataInfo?.productDescribeInfo && props.dataInfo?.productDescribeInfo.length > 0) ||
        props.dataInfo?.report?.reportParam?.paramDetail
      )
    })
    /**
     * $ 是否展示pk对比按钮
     */
    // TODO: 二奢融合 是否展示pk对比按钮
    const isShowButton = computed(() => {
      return props.dataInfo?.comparisonInfoVo?.showButton == 1
    })

    const levelDesc = computed(() => {
      // 存在两套等级说明逻辑 这里需要判断
      const conditionIntro = props.dataInfo?.report?.conditionIntro
      if (conditionIntro?.finenessDialogContents) {
        return (
          conditionIntro.finenessDialogContents?.find(
            (item) => item.finenessName == props.dataInfo?.infoLv?.level
          )?.title || ''
        )
      }
      return (
        conditionIntro?.data?.find((item) => item.conditionName == props.dataInfo?.infoLv?.level)
          ?.conditionLabel || ''
      )
    })

    const goodTags = computed(() => {
      return props.dataInfo?.costPerformanceExplain?.tagList?.map((item) => item.tagName) || []
    })

    /**
     * $ 榜单 尖货 备件库  品牌馆 baseInfo）
     */
    const rankInfoData = computed(() => {
      const data = {
        ...props.dataInfo.rankInfo,
        modelBrandInfo: props.dataInfo.modelBrandInfo || null,
        sourceInfo: props.dataInfo.sourceInfo || null,
        topGoodInfo: props.dataInfo.topGoodInfo || null
      }
      return data
    })

    // 金融分期模块
    const tagInfoData = computed(() => {
      return props.baseInfoMsg?.installmentInfo?.tagInfo || {}
    })
    //性价比解读
    const costPerformanceText = computed(() => {
      const { handPriceVo, costPerformanceExplain } = props.dataInfo
      return (
        (handPriceVo && handPriceVo.handPricePremiumContentNew) ||
        (costPerformanceExplain && costPerformanceExplain.detailShowText) ||
        ''
      )
    })

    // 埋点待完成
    onMounted(() => {
      //埋点
      $legoAreaExposure()
      const titleCheckMoreEl = goodsTitle.value
      if (titleCheckMoreEl.scrollHeight - titleCheckMoreEl.clientHeight > 5) {
        showTitleCheckMore.value = true
      }

      console.log('goodsTitle.value.', goodsTitle.value.scrollHeight, goodsTitle.value.clientHeight)
    })
    const service = computed(() => {
      return props.dataInfo?.serviceLogos?.slice(0, 4) || []
    })

    watch(
      () => state.actInfoVo,
      () => {
        calculateTime()
      },
      {
        immediate: true,
        deep: true
      }
    )

    function listenClickTab() {}

    function showAllTitle() {
      if (showTitleCheckMore.value) {
        if (titleExpand.value) {
          goodsTitle.value.style.maxHeight = 'none'
          titleExpand.value = false
        } else {
          goodsTitle.value.style.maxHeight = '3em'
          titleExpand.value = true
        }
      }
      // goodsTitle.value.style.maxHeight = 'none'
      // goodsTitle.value.children[0].css
      // console.log(goodsTitle.value.children[0])
    }

    //计算秒杀时间和秒杀状态
    function calculateTime() {
      if (!state.actInfoVo) {
        return
      }
      const { startTime, currentTime, endTime } = state.actInfoVo || {}
      if (currentTime < startTime) {
        promotionStatus.value = 1
      } else if (currentTime > startTime && currentTime < endTime) {
        promotionStatus.value = 2
      }
      if (promotionStatus.value > 0) {
        const startCountDown = startTime - currentTime
        const endCountDown = endTime - currentTime
        started.value = startCountDown <= 0
        if (startCountDown > 0) {
          countDownDesc.value = '距秒杀开始还剩'
          countDownTime.value = startCountDown
        } else if (endCountDown > 0) {
          countDownDesc.value = '距秒杀结束'
          countDownTime.value = endCountDown
        }
      }
    }

    //商品状态 0 无 | 1 红包 + 秒杀 | 2 秒杀 | 3 红包
    const priceStatus = computed(() => {
      const NORMAL_STATUS = 0
      const BOTH_STATUS = 1
      const SECKILL_STATUS = 2
      const RED_STATUS = 3
      let status = NORMAL_STATUS
      if (promotionStatus.value > 0 && props.dataInfo?.handPriceVo?.couponDownPriceCent) {
        status = BOTH_STATUS
      } else if (promotionStatus.value > 0 && !props.dataInfo?.handPriceVo?.couponDownPriceCent) {
        status = SECKILL_STATUS
      } else if (
        props.dataInfo?.coupons?.length ||
        props.dataInfo?.couponsCharged?.length ||
        props.dataInfo?.couponsNewUser?.length
      ) {
        status = RED_STATUS
      }
      return status
    })

    /**
     * $ 参数条信息（取 reportParams || params）
     * # reportParams：report?.reportParam?.paramBars
     * # params：report?.params
     */
    // TODO: 二奢融合 处理参数条信息
    const paramsBarInfo = computed(() => {
      const { report } = props.dataInfo
      const params = report?.params?.filter((item) => item.isBaseInfo == 0) || []
      const reportParams =
        report?.reportParam?.paramBars
          ?.slice(0, 10)
          .map(({ paramName: key, paramValue: value }) => ({ key, value })) || []
      return reportParams.length ? reportParams : params
    })

    const showParamsBar = () => {
      if (!paramsBar.value || !showQuantityPoup.value) return
      paramsBar.value.togglePopup()
    }

    watch(
      () => isScrolling.value,
      (newVal) => {
        !newVal &&
          direction.value === 'left' &&
          $legoSend({
            pagetype: 'slide',
            actiontype: 'T2974',
            slideType: direction.value,
            backup: {
              sectionId: 105,
              sortid: 10,
              sortname: '参数条'
            }
          })
      },
      { immediate: true } // 立即执行一次，以便在刚加载时判断滑动状态
    )

    watch(
      () => props.dataInfo,
      (val) => {
        if (val.title) {
          document.getElementsByClassName('product-infos__msg')[0].style.height = 'auto'
        }
      }
    )

    const handleScroll = () => {
      const element = document.getElementById('scrollEle') // 获取需要监听的元素
      element.addEventListener('touchstart', (event) => {
        startX.value = event.touches[0].clientX // 记录手指开始触摸时的 X 坐标
      })

      element.addEventListener('touchend', (event) => {
        endX.value = event.changedTouches[0].clientX // 记录手指离开屏幕时的 X 坐标

        const deltaX = startX.value - endX.value
        if (deltaX > 10 || startX.value == 0) {
          direction.value = 'left'
        } else if (deltaX < -10) {
          direction.value = 'right'
        }
      })
      clearTimeout(timer.value)
      isScrolling.value = true
      timer.value = setTimeout(() => {
        isScrolling.value = false
      }, 100) // 设置一个定时器，当 300ms 后滑动停止，更新滑动状态为 false
    }

    function countDownFinish() {
      countDownTime.value = 0
      promotionStatus.value = promotionStatus.value === 1 ? 2 : 0
      ctx.emit('updataList')
    }

    // 退货包邮模块
    const afterSalesService = computed(() => {
      const afterSalesService = props.dataInfo.afterSalesService || {}
      return afterSalesService
    })

    // pk对比
    const pkJump = () => {
      if (isShowButton.value) {
        if (props.dataInfo?.comparisonInfoVo?.jumpUrl) {
          skipToUrl({
            targetUrl: props.dataInfo.comparisonInfoVo.jumpUrl
          })
        }
      }
    }

    const updateBaseInfo = () => {
      ctx.emit('updataList')
    }

    /**
     * $ 监听腕表百科弹窗事件
     */
    // TODO: 二奢融合
    const openPopupWarchPedia = (data) => {
      ctx.emit('openPopupWarchPedia', data)
    }
    onUnmounted(() => {
      clearTimeout(timer.value)
    })

    return {
      service,
      handPriceVo,
      paramsBar,
      superLevel,
      promotionStatus,
      countDownDesc,
      countDownTime,
      priceStatus,
      paramsBarInfo,
      showParamsBar,
      isScrolling,
      startX,
      endX,
      direction,
      handleScroll,
      countDownFinish,
      state,
      getQueryString,
      showQuantityPoup,
      pkJump,
      isShowButton,
      afterSalesService,
      getSysType,
      goodsTitle,
      showTitleCheckMore,
      showAllTitle,
      titleExpand,
      qualityRef,
      levelDesc,
      goodTags,
      rankInfoData,
      tagInfoData,
      costPerformanceText,
      billionLevel,
      listenClickTab,
      openPopupWarchPedia,
      updateBaseInfo
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
.product-msg-wrapper {
  box-sizing: border-box;
  padding: 24px 32px;

  .mentality-bar {
    position: relative;
    z-index: 1;
    .process-item {
      display: flex;
      align-items: center;
      max-width: 592px;
      height: 32px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }

      &__wrapper {
        display: flex;
        .item {
          white-space: nowrap;
        }
        .dot {
          margin: 0 10px;
        }
      }
    }

    .arrow {
      position: absolute;
      right: 0;
      z-index: 10;
      width: 30px;
      height: 30px;
      margin-right: 20px;
    }
  }

  .product-infos {
    min-height: 300px;
    background: #fff;

    .cost-performance {
      position: relative;
      top: -1px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .first-icon {
        width: 20px;
        height: 20px;
        margin-right: 6px;
      }
      .cost-desc {
        color: #ffffff;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 22px;
        white-space: nowrap;
        opacity: 0.7;
      }
      .end-icon {
        width: 10px;
        height: 18px;
        margin-left: 6px;
      }
    }

    &__msg {
      box-sizing: border-box;
      height: 370px;
      padding: 26px 24px 32px;
      background: #f8f8f8;
      border-radius: 16px 16px 32px;

      .good-title_wrapper {
        display: flex;
        overflow: hidden;
        .text {
          position: relative;
          max-height: 3em;
          overflow: hidden;
          color: #000000;
          font-weight: 400;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 42px;
          text-overflow: ellipsis;
          .sales-return {
            position: relative;
            bottom: 4px;
            display: inline-flex;
            align-items: center;
            height: 32px;
            margin-left: 7px;
            padding: 0 10px;
            color: #111111;
            font-weight: 300;
            font-size: 20px;
            font-family: PingFangSC-Light, PingFang SC;
            line-height: 32px;
            background: linear-gradient(137deg, #d6f3ff 0%, #dcfff3 100%);
            border-radius: 4px;

            .right {
              width: 9px;
              height: 16px;
              margin-left: 4px;
            }
          }
        }
        .text::before {
          float: right;
          height: calc(100% - 26px);
          content: '';
        }
        .float-right {
          position: relative;
          top: 0;
          float: right;
          clear: both;
          margin-top: -12px;
          color: #fff;
          .title-bottom-icon {
            position: relative;
            top: 3px;
            padding-left: 30px;
            color: #111;
            transition: all 0.2s;
          }
          .title-top-icon {
            position: relative;
            top: 0;
            padding-right: 20px;
            padding-left: 0;
            transform: rotate(180deg);
            transition: all 0.2s;
          }
          .dot {
            color: #111;
          }
        }
      }

      .good-tag_wrapper {
        box-sizing: border-box;
        margin-top: 10px;
        margin-bottom: 20px;
        overflow-x: scroll;
        overflow-y: hidden;
        &::-webkit-scrollbar {
          display: none;
        }

        .tag-list {
          display: flex;

          &__item {
            display: flex;
            align-items: center;
            color: #999999;
            font-weight: 300;
            font-size: 20px;
            font-family: PingFangSC-Light, PingFang SC;
            line-height: 22px;
            white-space: nowrap;
            .dot {
              display: inline-block;
              width: 3px;
              height: 3px;
              margin: 0 10px;
              background: #999;
            }
          }
        }
      }

      .dashed {
        position: relative;
        margin-top: 28px;
        &::before {
          position: absolute;
          width: 100%;
          height: 1px;
          background: url('https://pic4.zhuanstatic.com/zhuanzh/3ff0f757-9988-40c1-bea2-d44d0f1b8162.png')
            no-repeat top left;
          background-size: 100% 100%;
          content: '';
        }
      }

      .quality-level {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 25px;
        &__left {
          display: flex;
          align-items: center;
        }
        &__condition {
          position: relative;
          display: flex;
          align-items: center;
          &.old-style {
            position: relative;
            top: 0;
            margin-top: -10px;
            &::after {
              position: absolute;
              width: 30px;
              height: 30px;
              content: '';
            }
          }

          .quality-icon {
            position: relative;
            top: -0.5px;
            width: 24px;
            height: 24px;
            margin-left: 8px;

            &.old-style {
              position: relative;
              top: -3px;
              width: 18px;
              height: 18px;
            }
          }
          .quality-desc {
            color: #111111;
            font-weight: 500;
            font-size: 26px;
            font-family: PingFangSC-Medium, PingFang SC;
            line-height: 28px;
          }
        }

        &__right {
          position: relative;
          margin-top: -1px;
          color: #111111;
          font-weight: 300;
          font-size: 20px;
          font-family: PingFangSC-Light, PingFang SC;
          line-height: 20px;

          &::after {
            @include hairline(#111111);
            margin-bottom: -4px;
            border-bottom-width: 1px;
          }
        }
        .line {
          position: relative;
          display: inline-block;
          width: 1px;
          height: 22px;
          margin: 0 20px;

          &::after {
            @include hairline(#c6c6c6);
            border-left-width: 1px;
          }
        }
      }
      .bottom-info {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 24px;
        padding-right: 40px;
        .report-param {
          position: relative;
          box-sizing: border-box;
          padding-right: 20px;
          overflow-x: scroll;
          overflow-y: hidden;
          color: #999999;
          font-weight: 400;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          white-space: nowrap;

          &::after {
            border: none;
          }
          .report-item {
            display: inline-flex;
            align-items: center;
            &__text {
              display: flex;
              flex-direction: column;
              font-family: PingFangSC-Light, PingFang SC;
              p {
                color: #999999;
                font-weight: 300;
                font-size: 20px;
                font-family: PingFangSC-Light, PingFang SC;
                line-height: 22px;
              }
              p:first-child {
                margin-bottom: 12px;
                color: #000000;
                font-weight: 600;
                font-size: 22px;
                font-family: PingFangSC-Semibold, PingFang SC;
                line-height: 24px;
              }
            }
            .line {
              position: relative;
              top: 10px;
              width: 1px;
              height: 40px;
              margin: 0 24px;
              background: #f8f8f8;
              transform: scale(0.5, 0.5);
              transform-origin: 0 0;
            }
            &:last-child {
              .line {
                display: none;
              }
            }
          }
          &::-webkit-scrollbar {
            display: none;
          }
        }
        .arrow {
          position: absolute;
          top: 0;
          right: 0;
          z-index: -1;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          width: 120px;
          height: 72px;
          margin-top: -12px;
          background: linear-gradient(90deg, rgba(248, 248, 248, 0) 0%, #f8f8f8 100%);

          img {
            width: 24px;
            height: 24px;
            margin-top: 15px;
            object-fit: cover;
          }
        }
      }
    }
  }
}
</style>
